import { DialogCloseDirective } from './dialog-close.directive';
import { DialogContentComponent } from './dialog-content.component';
import { DialogFooterComponent } from './dialog-footer.component';
import { DialogHeaderComponent } from './dialog-header.component';

export const DIALOG_IMPORTS = [
  DialogHeaderComponent,
  DialogContentComponent,
  DialogFooterComponent,
  DialogCloseDirective,
] as const;

export { DialogCloseDirective } from './dialog-close.directive';
export { DialogContentComponent } from './dialog-content.component';
export { DialogFooterComponent } from './dialog-footer.component';
export { DialogHeaderComponent } from './dialog-header.component';
export { DialogService } from './dialog.service';
export { AppDialogRef } from './dialog-ref';
export { APP_DIALOG_DATA } from './dialog.tokens';
export type { AppDialogOptions, DialogPresentation, DialogSize, DialogTone } from './dialog-config';
